module.exports = __webpack_public_path__ + "static/media/arrow-left.e8dbe19e.cur";